{
  "version": "1.2.6",
  "objects": {
    "7430093515431752237": {
      "type": "frame",
      "id": "7430093515431752237",
      "z": 7213,
      "textContent": "",
      "left": 1110.9264409046527,
      "top": 2299.4220234004983,
      "width": 400,
      "height": 500,
      "scaleX": 1.3412816270876966,
      "scaleY": 1.4274375,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": null,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a4zzzzz",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 30,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430093515428600487": {
      "type": "frame",
      "id": "7430093515428600487",
      "z": 6975,
      "textContent": "Frame 20",
      "left": 1140.9264409046527,
      "top": 2943.2813984004983,
      "width": 400,
      "height": 500,
      "scaleX": 1.1828702366509969,
      "scaleY": 0.07971875,
      "fill": "transparent",
      "opacity": 1,
      "container": "7430093515431752237",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a6",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7430093515431440600": {
      "type": "wireframe",
      "id": "7430093515431440600",
      "z": 6980,
      "top": 2943.2813984004983,
      "left": 1140.9264409046527,
      "width": 473.0418406579338,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430093515428600487",
      "layoutPosition": "a2",
      "wireframeName": "button",
      "fill": "#3AA78B",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Save changes" },
      "setDimension": true
    },
    "7430093515431290351": {
      "type": "wireframe",
      "id": "7430093515431290351",
      "z": 6978,
      "top": 2621.4220234004983,
      "left": 1140.9264409046527,
      "width": 476.55158464924625,
      "height": 65.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430093515431752237",
      "layoutPosition": "a4zzzzx",
      "wireframeName": "dropdown",
      "fill": "#CACACA",
      "itemsData": {
        "7426825324790671900": {
          "id": "7426825324790671900",
          "value": "Item",
          "item_position": 2000000
        },
        "7426825324790728864": {
          "id": "7426825324790728864",
          "value": "Item",
          "item_position": 1000000
        },
        "7426825324794315228": {
          "id": "7426825324794315228",
          "value": "Item",
          "item_position": 0
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Dropdown title", "position": "outside" },
      "placeholder": {
        "state": "placeholder",
        "value": "Settings title",
        "iconRight": { "prefix": "fas", "iconName": "angle-down" }
      },
      "setDimension": true
    },
    "7430093515437165010": {
      "type": "frame",
      "id": "7430093515437165010",
      "z": 6980,
      "textContent": "Frame 44",
      "left": 1140.9264409046527,
      "top": 2475.4220234004983,
      "width": 400,
      "height": 500,
      "scaleX": 1.1912816270876965,
      "scaleY": 0.086,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515431752237",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a3",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430093515433500470": {
      "type": "shape",
      "id": "7430093515433500470",
      "z": 6981,
      "shapeName": "text",
      "textContent": "<p><strong>Settings title 3</strong></p>",
      "left": 1140.9264409046527,
      "top": 2479.9220234004983,
      "width": 105.875,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7430093515437165010",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7430093515434046033": {
      "type": "frame",
      "id": "7430093515434046033",
      "z": 6985,
      "textContent": "Frame 42",
      "left": 1530.7633104897313,
      "top": 2475.4220234004983,
      "width": 400,
      "height": 500,
      "scaleX": 0.216689453125,
      "scaleY": 0.086,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515437165010",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430093515438954687": {
      "type": "wireframe",
      "id": "7430093515438954687",
      "z": 6986,
      "top": 2485.4220234004983,
      "left": 1540.7633104897313,
      "width": 66.67578125,
      "height": 23,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430093515434046033",
      "layoutPosition": "a3",
      "wireframeName": "toggle",
      "fill": "#4F8F0E",
      "textColor": "#333333",
      "style": "roundFilled",
      "componentState": "on",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "On", "position": "right" },
      "placeholder": {}
    },
    "7430094637523546134": {
      "type": "frame",
      "id": "7430094637523546134",
      "z": 6991,
      "textContent": "Frame 44",
      "left": 1140.9264409046527,
      "top": 2329.4220234004983,
      "width": 400,
      "height": 500,
      "scaleX": 1.1912816270876965,
      "scaleY": 0.086,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515431752237",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430094637535329049": {
      "type": "frame",
      "id": "7430094637535329049",
      "z": 6992,
      "textContent": "Frame 42",
      "left": 1530.7633104897313,
      "top": 2329.4220234004983,
      "width": 400,
      "height": 500,
      "scaleX": 0.216689453125,
      "scaleY": 0.086,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430094637523546134",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430094637525143386": {
      "type": "wireframe",
      "id": "7430094637525143386",
      "z": 6993,
      "top": 2339.4220234004983,
      "left": 1540.7633104897313,
      "width": 66.67578125,
      "height": 23,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430094637535329049",
      "layoutPosition": "a3",
      "wireframeName": "toggle",
      "fill": "#4F8F0E",
      "textColor": "#333333",
      "style": "roundFilled",
      "componentState": "on",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "On", "position": "right" },
      "placeholder": {}
    },
    "7430094637534942337": {
      "type": "shape",
      "id": "7430094637534942337",
      "z": 6994,
      "shapeName": "text",
      "textContent": "<p><strong>Settings title 1</strong></p>",
      "left": 1140.9264409046527,
      "top": 2333.9220234004983,
      "width": 105.875,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7430094637523546134",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "Zz",
      "maskType": "none",
      "locked": false
    },
    "7430093515438285927": {
      "type": "frame",
      "id": "7430093515438285927",
      "z": 6993,
      "textContent": "Frame 44",
      "left": 1140.9264409046527,
      "top": 2402.4220234004983,
      "width": 400,
      "height": 500,
      "scaleX": 1.1912816270876965,
      "scaleY": 0.086,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515431752237",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430093515437793665": {
      "type": "shape",
      "id": "7430093515437793665",
      "z": 6994,
      "shapeName": "text",
      "textContent": "<p><strong>Settings title 2</strong></p>",
      "left": 1140.9264409046527,
      "top": 2406.9220234004983,
      "width": 105.875,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7430093515438285927",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "Zz",
      "maskType": "none",
      "locked": false
    },
    "7430093515439711774": {
      "type": "frame",
      "id": "7430093515439711774",
      "z": 6995,
      "textContent": "Frame 42",
      "left": 1530.7633104897313,
      "top": 2402.4220234004983,
      "width": 400,
      "height": 500,
      "scaleX": 0.216689453125,
      "scaleY": 0.086,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515438285927",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430093515442788367": {
      "type": "wireframe",
      "id": "7430093515442788367",
      "z": 6996,
      "top": 2412.4220234004983,
      "left": 1540.7633104897313,
      "width": 66.67578125,
      "height": 23,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430093515439711774",
      "layoutPosition": "a3",
      "wireframeName": "toggle",
      "fill": "#4F8F0E",
      "textColor": "#333333",
      "style": "roundFilled",
      "componentState": "on",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "On", "position": "right" },
      "placeholder": {}
    },
    "7430094245375224115": {
      "type": "frame",
      "id": "7430094245375224115",
      "z": 6997,
      "textContent": "Frame 44",
      "left": 1140.9264409046527,
      "top": 2717.2813984004983,
      "width": 400,
      "height": 500,
      "scaleX": 0.28,
      "scaleY": 0.392,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515431752237",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a5V",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7430094245372915410": {
      "type": "frame",
      "id": "7430094245372915410",
      "z": 6998,
      "textContent": "Frame 172",
      "left": 1140.9264409046527,
      "top": 2761.2813984004983,
      "width": 400,
      "height": 500,
      "scaleX": 0.2623095703125,
      "scaleY": 0.304,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430094245375224115",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 30,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430094245373411745": {
      "type": "wireframe",
      "id": "7430094245373411745",
      "z": 6999,
      "top": 2879.2813984004983,
      "left": 1151.4264409046527,
      "width": 84.923828125,
      "height": 24,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430094245372915410",
      "layoutPosition": "a2",
      "wireframeName": "checkbox",
      "fill": "#808080",
      "textColor": "#333333",
      "componentState": "checkbox",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Option 3", "position": "right" },
      "placeholder": {}
    },
    "7430094245376147208": {
      "type": "wireframe",
      "id": "7430094245376147208",
      "z": 7000,
      "top": 2825.2813984004983,
      "left": 1151.4264409046527,
      "width": 84.923828125,
      "height": 24,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430094245372915410",
      "layoutPosition": "a1",
      "wireframeName": "checkbox",
      "fill": "#808080",
      "textColor": "#333333",
      "componentState": "checkbox",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Option 2", "position": "right" },
      "placeholder": {}
    },
    "7430094245385891504": {
      "type": "wireframe",
      "id": "7430094245385891504",
      "z": 7002,
      "top": 2771.2813984004983,
      "left": 1151.4264409046527,
      "width": 84.923828125,
      "height": 24,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430094245372915410",
      "layoutPosition": "a0",
      "wireframeName": "checkbox",
      "fill": "#808080",
      "textColor": "#333333",
      "componentState": "checkbox",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Option 1", "position": "right" },
      "placeholder": {}
    },
    "7430094245377761044": {
      "type": "shape",
      "id": "7430094245377761044",
      "z": 7001,
      "shapeName": "text",
      "textContent": "<p><strong>Settings title </strong></p>",
      "left": 1140.9264409046527,
      "top": 2717.2813984004983,
      "width": 98,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7430094245375224115",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7430094019512173994": {
      "type": "frame",
      "id": "7430094019512173994",
      "z": 7323,
      "textContent": "Frame 44",
      "left": 1140.9264409046527,
      "top": 2548.4220234004983,
      "width": 400,
      "height": 500,
      "scaleX": 1.1912816270876965,
      "scaleY": 0.086,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515431752237",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a4",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430094019509645332": {
      "type": "shape",
      "id": "7430094019509645332",
      "z": 7136,
      "shapeName": "text",
      "textContent": "<p><strong>Settings title 4</strong></p>",
      "left": 1140.9264409046527,
      "top": 2552.9220234004983,
      "width": 105.875,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7430094019512173994",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7430094019515835413": {
      "type": "frame",
      "id": "7430094019515835413",
      "z": 7137,
      "textContent": "Frame 42",
      "left": 1530.7633104897313,
      "top": 2548.4220234004983,
      "width": 400,
      "height": 500,
      "scaleX": 0.216689453125,
      "scaleY": 0.086,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430094019512173994",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430094019513708033": {
      "type": "wireframe",
      "id": "7430094019513708033",
      "z": 7138,
      "top": 2558.4220234004983,
      "left": 1540.7633104897313,
      "width": 66.416015625,
      "height": 23,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430094019515835413",
      "layoutPosition": "a3",
      "wireframeName": "toggle",
      "fill": "#BDBDBD",
      "textColor": "#333333",
      "style": "roundFilled",
      "componentState": "off",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Off", "position": "right" },
      "placeholder": {}
    }
  }
}
